import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { ForgotService } from 'src/app/shared/Forgot.Service';
import { Router } from '@angular/router';
import { Forgot } from 'src/app/shared/forgot.model';
import * as textMask from 'vanilla-text-mask/dist/vanillaTextMask.js';
import { AppInsightsService } from '../../shared/AppInsights.Service';

@Component({
  selector: 'app-client-pass',
  templateUrl: './client-pass.component.html',
  styleUrls: ['./client-pass.component.scss']
})
export class ClientPassComponent implements OnInit, AfterViewInit, OnDestroy {
  public type: string;
  public show = false;
  public userid = '';
  public govid = '';
  public pasteData = '';
  public pasteInd = 'N';
  public error = false;
  public isLoading = false;
  public validate = true;
  public showPlaceholder: boolean;
  public formErrorFields: any = {
    userid: false,
    govid: false
  };
  forgot: Forgot;
  message: any;
  constructor(private forgotService: ForgotService, private router: Router, private appInsightsService: AppInsightsService) { }

  ssnmask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]; // 000-00-0000
  maskedInputController;

  @ViewChild('user') public user: ElementRef;
  @ViewChild('ssn') public ssn: ElementRef;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.maskedInputController = textMask.maskInput({
        inputElement: this.ssn.nativeElement,
        mask: this.ssnmask,
        guide: false
      });
    });
  }
  ngOnDestroy() {
    this.maskedInputController.destroy();
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.showPlaceholder = true;
    this.type = 'password'; // display as '*'
    this.appInsightsService.logEvent("Forgot UI Page - Client Password");
  }
  
  setPlaceholder(ele) {
    if (this.showPlaceholder) {
      ele.setAttribute('placeholder', ele.getAttribute('data-placeholder'));
    } else {
      ele.setAttribute('placeholder', '');
    }
  }
  
  togglePlaceholder(event: FocusEvent) {
    this.showPlaceholder = !this.showPlaceholder;
    this.setPlaceholder(event.target);
  }
  
  numberOnly(event) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && !pattern.test(inputChar)) {
      return event.preventDefault();
    }
    return true;
  }

  focusOnInput() {
    let setError = false;
    if (!!this.formErrorFields.userid) {
      setError = true;
      setTimeout(() => this.user.nativeElement.focus(), 0);
      setTimeout(() => this.user.nativeElement.select(), 0);
      window.scrollTo(0,this.user.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    } else if (!!this.formErrorFields.govid || !!this.formErrorFields.govidVal) {
      setError = true;
      setTimeout(() => this.ssn.nativeElement.focus(), 0);
      setTimeout(() => this.ssn.nativeElement.select(), 0);
      window.scrollTo(0,this.ssn.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    }
    return setError;
  }

  isErrorPresent() {
    if (!this.formErrorFields.userid && !this.formErrorFields.govid && !this.formErrorFields.govidVal) {
      return false;
    } else {
      return true;
    }
  }

  validateAllFields() {
    const fields = ['userid', 'govid'];
    let isErrPresent = false;
    for (let j = 0; j < fields.length; j++) {
      isErrPresent = this.validateForm(fields[j]);
      if (isErrPresent) {
        break;
      }
    }
    return isErrPresent;
  }

  ifAtleastOneFieldValidated(model) {
    this.validate = !!this[model] ? false : true;
    return this.validate;
  }
  
  validateOnKeyPress(model){
    if(model === 'govid'){
      if(!!this.govid && this.govid.replace(/[- ()]/g, '').length === 9){
        this.validateForm('govid');
      }
    }
  }

  validateForm(model) {
    let error = false;
    this.validate = true;
    if (model === 'userid') {
      if (!this.userid) {
        this.formErrorFields.userid = true;
        error = true;
      } else {
        this.formErrorFields.userid = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }
    if (model === 'govid') {
      if (!this.govid) {
        this.formErrorFields.govid = true;
        this.formErrorFields.govidVal = false;
        error = true;
      } else if (this.govid.replace(/[- ()]/g, '').length !== 9) {
        this.formErrorFields.govid = false;
        this.formErrorFields.govidVal = true;
        error = true;
      } else {
        this.formErrorFields.govid = false;
        this.formErrorFields.govidVal = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }

    if (!!this.userid && !!this.govid && !this.isErrorPresent() && !error) {
      this.validate = error;
    }
    return error;
  }

  toggleShow() {
    this.show = !this.show;
    if (this.show) {
      this.type = 'text';
    } else {
      this.type = 'password';
    }
  }

  cancel() {
    this.router.navigate(['client']);
  }

  continue(id: string, _ssn: string) {
    if (!this.validateAllFields()) {
      if (this.pasteData.replace(/[- ()]/g, '') === _ssn.replace(/[- ()]/g, '')) {
        this.pasteInd = 'Y';
      } else {
        this.pasteInd = 'N';
      }
      setTimeout(() => {
        window.scrollTo(0, 0);
        this.error = false;
        this.isLoading = true;
        this.validate = true;
      });
      const userId = id;
      const ssn = _ssn.replace(/[- ()]/g, '');
      const userType = 'client';
      const pasted = this.pasteInd;
      const bodyString = JSON.stringify({ userId, ssn, userType, pasted });
      this.forgotService.getPassword(bodyString).subscribe(res => {
        this.forgot = res;
        if (this.forgot) {         
          if (this.forgot.status_code && this.forgot.status_code !== '200') {
            setTimeout(() => {
	            this.isLoading = false;
	          });
            this.message = this.forgot.message;
            if (!this.message) {
              this.message = 'Session has expired please close browser and try again';
            }
            this.error = true;
            this.validate = false;
            setTimeout(() => {
		      this.maskedInputController = textMask.maskInput({
		        inputElement: this.ssn.nativeElement,
		        mask: this.ssnmask,
		        guide: false
		      });
		    });
          } else {
            this.error = false;
            let url = false;
            let question = false;
            if (this.forgot.url && !question) {
              url = true;
              console.log('url ' + this.forgot.url);
              window.location.href = this.forgot.url;
            }

            if (this.forgot.questions && !url) {
              question = true;
              this.forgotService.setUserType('client');
              this.forgotService.setQuestions(this.forgot.questions);
              this.router.navigate(['/questions']);
            }
          }
        }
      });
    } else {
      this.focusOnInput();
    }
  }

  paste(event: ClipboardEvent) {
    if (event && event.clipboardData) {
      this.pasteData = event.clipboardData.getData('text');
    }
  }


}
